export const isSmartLinkDraggingClass = 'is-smart-link-dragging';
export const smartLinkDropOverClass = 'smart-link-drop-over';
export const SMART_LINK_DND_ANALYTICS_SOURCE = 'smartLinkDnD';
